import { LazyLoadImage } from "react-lazy-load-image-component";
import { forwardRef } from 'react';
import { inquiryType } from '@Components/Utilities/SandhillsConstants';
import useKeyPress from '@Components/Utilities/KeyPress';
import translator from '@Components/Utilities/Translator';

const BadgeList = forwardRef((props, ref) => {

    if (props.Badges && props.Badges.length > 0) {

        return (
            <div className='badge-container'>
                {props.Badges.map(badge =>
                    <div key={badge.BadgeText} className='badge'>
                        {props.IsRedesign ?
                            <div className='badge__text'>{badge.BadgeText}</div>
                            :
                            <div>
                                <LazyLoadImage src={badge.ImageUrl} className='badge__image' alt="" />
                                <span className='badge__text'>{badge.BadgeText}</span>
                            </div>
                        }
                    </div>)}
            </div>
        );
    } else {
        return (<></>);
    }
});

export default BadgeList;